import { ref, watch, nextTick } from 'vue';
import { Duration } from '../../animations/component-lib.esm.js';
function useAccordion(options) {
  const {
    modelValue,
    root,
    summary,
    content,
    disabled
  } = options;
  const animation = ref(null);
  const isOpen = ref(modelValue.value);
  watch(modelValue, newValue => {
    if (newValue) animateOpen();else animateClose();
  });
  async function animateOpen() {
    const startHeight = `${root.value.offsetHeight}px`;
    root.value.style.height = startHeight;
    isOpen.value = true;
    await nextTick();
    window.requestAnimationFrame(() => {
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${summary.value.offsetHeight + content.value.offsetHeight}px`;
      if (animation.value) {
        animation.value.cancel();
      }
      animation.value = root.value.animate({
        height: [startHeight, endHeight]
      }, {
        duration: Duration.STANDARD,
        easing: 'ease-out'
      });
      animation.value.onfinish = () => {
        animation.value = null;
        root.value.style.height = null;
        root.value.style.overflow = null;
      };
    });
  }
  async function animateClose() {
    const startHeight = `${root.value.offsetHeight}px`;
    root.value.style.height = startHeight;
    isOpen.value = false;
    await nextTick();
    window.requestAnimationFrame(() => {
      // Calculate the closed height of the element (summary height)
      const endHeight = `${summary.value.offsetHeight}px`;
      if (animation.value) {
        animation.value.cancel();
      }
      animation.value = root.value.animate({
        height: [startHeight, endHeight]
      }, {
        duration: Duration.STANDARD,
        easing: 'ease-out'
      });
      animation.value.onfinish = () => {
        animation.value = null;
        root.value.style.height = null;
        root.value.style.overflow = null;
      };
    });
  }
  function handleClick() {
    if (disabled.value) return;
    root.value.style.overflow = 'hidden';
    if (isOpen.value) {
      animateClose();
    } else {
      animateOpen();
    }
  }
  return {
    handleClick,
    isOpen
  };
}
export { useAccordion };